import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from '../Pwg/Modal';
import ActivationPWG from './ActivationPWG';

function ResourceSummaryTable() {
  const [records, setRecords] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  
  // Modal states
  const [activationModalOpen, setActivationModalOpen] = useState(false);
  const [swapModalOpen, setSwapModalOpen] = useState(false);
  const [billingCodeModalOpen, setBillingCodeModalOpen] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);

  // Form states
  const [swapForm, setSwapForm] = useState({
    mdn: '',
    sim: '',
    imei: '',
    newZip: ''
  });
  const [billingCodeForm, setBillingCodeForm] = useState({
    mdn: '',
    billingCode: ''
  });
  const [apiLoading, setApiLoading] = useState(false);
  const [apiMessage, setApiMessage] = useState({ type: '', text: '' });
                const [billingCodes] = useState(['GIG3','GIG625','GIG12', 'GIG175', 'GIG23', 'GIG34', 'GIG45']);
const [planCodeModalOpen, setPlanCodeModalOpen] = useState(false);
const [planCodeForm, setPlanCodeForm] = useState(false);
 const [plans] = useState([
    { id: '01', name: '1 GB 30 Days' },
    { id: '02', name: '2.5 GB 30 Days' },
    { id: '03', name: '5 GB 30 Days' },
    { id: '04', name: '7.5 GB 30 Days' },
    { id: '05', name: '10 GB 30 Days' },
    { id: '06', name: '15 GB 30 Days' },
    { id: '07', name: '20 GB 30 Days' },
    { id: '08', name: '1 GB 30 Days' },
    { id: '09', name: '2.5 GB 30 Days' }
  ]);
const token ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyYzFhZTY2OS04ZThlLTQ5ZDItYWE4NS1jZmM0NjdmNTVhYTciLCJzdWIiOiIxMCIsImVtYWlsIjoicGF3YW4ua0BjbGF5LmNvLmluIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQWRtaW4iLCJEYXRlIjoiMTIvMTIvMjAyNSAxMjozNToxMyBQTSIsImV4cCI6MTc2NTk1NTExMywiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NDQzODQvIiwiYXVkIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NDQzODQvIn0.HL5ROu1YQW_CGwTKpOyLDRPRR-L0pO6EibQJfa2k-Mg"

  const fetchRecords = async (from = '', to = '') => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.post('https://pwg.clay.in/api/CDR/GetResourceSummaryRecords', {
        resource: '',
        pageIndex: 1,
        pageSize: 800,
        fromDate: from,
        toDate: to
      }, {
        headers: {
          
          'Content-Type': 'application/json',
          'accept': '*/*'
        }
      });

      if (response.data?.isSuccess) {
        setRecords(response.data.records || []);
      } else {
        const errorMsg = response.data?.message || 'Failed to fetch records';
        console.error('Failed to fetch records:', errorMsg);
        setError(errorMsg);
        setRecords([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Network error. Please try again.');
      setRecords([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const handleDateChange = () => {
    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      setError('From date cannot be after To date');
      return;
    }
    setError(null);
    setCurrentPage(1);
    fetchRecords(fromDate, toDate);
  };

  const handleReset = () => {
    setFromDate('');
    setToDate('');
    setSearchTerm('');
    setCurrentPage(1);
    setItemsPerPage(10);
    setSortConfig({ key: null, direction: 'ascending' });
    fetchRecords();
  };

  const bytesToMB = (bytes) => (bytes / (1024 * 1024)).toFixed(2);

  // Modal handlers
  const handleSwapClick = (resource) => {
    setSelectedResource(resource);
    // Extract MDN from resource (assuming resource is the MDN or contains it)
    const mdn = resource.resource || resource.mdn || '';
    setSwapForm({
      mdn: mdn,
      sim: '',
      imei: '',
      newZip: ''
    });
    setApiMessage({ type: '', text: '' });
    setSwapModalOpen(true);
  };

  const handleBillingCodeClick = (resource) => {
    setSelectedResource(resource);
    // Extract MDN from resource and get current billing code
    const mdn = resource.resource || resource.mdn || '';
    const currentBillingCode = resource.latestBillingCode || '';
    setBillingCodeForm({
      mdn: mdn,
      billingCode: currentBillingCode
    });
    setApiMessage({ type: '', text: '' });
    setBillingCodeModalOpen(true);
  };

  // API Calls
  const handleSwapMDN = async () => {
    if (!swapForm.mdn || !swapForm.sim) {
      setApiMessage({ type: 'error', text: 'MDN and SIM are required fields' });
      return;
    }

    try {
      setApiLoading(true);
      setApiMessage({ type: '', text: '' });

      const response = await axios.post('https://pwg.clay.in/api/Pwg/SwapEsn', {
        request: {
          type: "SwapESN", // You might need to adjust this based on API requirements
          mdn: swapForm.mdn,
          newEsn: swapForm.sim,
          oldEsn: swapForm.imei || "string", // Send as "string" if empty, or adjust based on API
        }
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'accept': '*/*'
        }
      });

      if (response.data.success) {
        setApiMessage({ 
          type: 'success', 
          text: 'MDN swapped successfully!' 
        });
        // Reset form and close modal after success
        setTimeout(() => {
          setSwapModalOpen(false);
          setSwapForm({ mdn: '', sim: '', imei: '', newZip: '' });
          fetchRecords(); // Refresh data
        }, 2000);
      } else {
        setApiMessage({ 
          type: 'error', 
          text: `Swap failed: ${response.data.data?.status || 'Unknown error'}` 
        });
      }
    } catch (error) {
      console.error('Swap MDN error:', error);
      setApiMessage({ 
        type: 'error', 
        text: `Error: ${error.response?.data?.message || error.message}` 
      });
    } finally {
      setApiLoading(false);
    }
  };

  const handleChangeBillingCode = async () => {
    if (!billingCodeForm.mdn || !billingCodeForm.billingCode) {
      setApiMessage({ type: 'error', text: 'MDN and Billing Code are required fields' });
      return;
    }

    try {
      setApiLoading(true);
      setApiMessage({ type: '', text: '' });

      const response = await axios.post('https://pwg.clay.in/api/Pwg/ChangeBillingCode', {
        request: {
          type: "ChangeBillingCode", // You might need to adjust this based on API requirements
          mdn: billingCodeForm.mdn,
          billingCode: billingCodeForm.billingCode
        }
      }, {
        headers: {
                    Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'accept': '*/*'
        }
      });

      if (response.data.response?.status === "success") {
        setApiMessage({ 
          type: 'success', 
          text: 'Billing code updated successfully!' 
        });
        // Reset form and close modal after success
        setTimeout(() => {
          setBillingCodeModalOpen(false);
          setBillingCodeForm({ mdn: '', billingCode: '' });
          fetchRecords(); // Refresh data
        }, 2000);
      } else {
        setApiMessage({ 
          type: 'error', 
          text: `Billing code change failed: ${response.data.response?.status || 'Unknown error'}` 
        });
      }
    } catch (error) {
      console.error('Change Billing Code error:', error);
      setApiMessage({ 
        type: 'error', 
        text: `Error: ${error.response?.data?.message || error.message}` 
      });
    } finally {
      setApiLoading(false);
    }
  };

const handlePlanCodeClick = (resource) => {
  setSelectedResource(resource);
  // Extract MDN from resource
  const mdn = resource.resource || resource.mdn || '';
  setPlanCodeForm({
    mdn: mdn,
    sim: '',
    newPlanID: '',
    newZip: '',
    e911Address: {
      street1: '',
      street2: '',
      city: '',
      state: '',
      zip: ''
    }
  });
  setApiMessage({ type: '', text: '' });
  setPlanCodeModalOpen(true);
};
const handleChangePlanCode = async () => {
  if (!planCodeForm.mdn || !planCodeForm.sim || !planCodeForm.newPlanID) {
    setApiMessage({ type: 'error', text: 'MDN, SIM, and Plan ID are required fields' });
    return;
  }

  try {
    setApiLoading(true);
    setApiMessage({ type: '', text: '' });

    const response = await axios.post('https://pwg.clay.in/api/Pwg/ChangePlan', {
      request: {
        type: 'ChangePlan',
        mdn: planCodeForm.mdn,
        sim: planCodeForm.sim,
        newplanID: planCodeForm.newPlanID,
        newZip: planCodeForm.newZip,
        e911ADDRESS: {
          streeT1: planCodeForm.e911Address.street1 || "string",
          streeT2: planCodeForm.e911Address.street2 || "string",
          city: planCodeForm.e911Address.city || "string",
          state: planCodeForm.e911Address.state || "string",
          zip: planCodeForm.e911Address.zip || "94105"
        }
      }
    }, {
      headers: {
                  Authorization: `Bearer ${token}`,

        'Content-Type': 'application/json',
        'accept': '*/*'
      }
    });

    if (response.data.response?.status === "success") {
      setApiMessage({ 
        type: 'success', 
        text: 'Plan Code Changed Successfully' 
      });
      // Reset form and close modal after success
      setTimeout(() => {
        setPlanCodeModalOpen(false);
        setPlanCodeForm({ 
          mdn: '', 
          sim: '', 
          newPlanID: '', 
          newZip: '',
          e911Address: {
            street1: '',
            street2: '',
            city: '',
            state: '',
            zip: ''
          }
        });
        fetchRecords(); // Refresh data
      }, 2000);
    } else {
      setApiMessage({ 
        type: 'error', 
        text: `Plan code change failed: ${response.data.response?.status || 'Unknown error'}` 
      });
    }
  } catch (error) {
    console.error('Change Plan Code error:', error);
    setApiMessage({ 
      type: 'error', 
      text: `Error: ${error.response?.data?.message || error.message}` 
    });
  } finally {
    setApiLoading(false);
  }
};
  // Reset modals when closed
  const resetModals = () => {
    setSwapForm({ mdn: '', sim: '', imei: '', newZip: '' });
    setBillingCodeForm({ mdn: '', billingCode: '' });
    setApiMessage({ type: '', text: '' });
    setApiLoading(false);
  };

  const totalBillableUnits = records.reduce((sum, rec) => sum + rec.total_billable_units, 0);
  const totalChargedPrice = records.reduce((sum, rec) => sum + rec.total_charged_price, 0);
  const totalFreeUnits = records.reduce((sum, rec) => sum + rec.total_free_units_applied, 0);

  const filteredRecords = records.filter(record => 
    record.resource.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedRecords = React.useMemo(() => {
    let sortableItems = [...filteredRecords];
    if (sortConfig.key !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [filteredRecords, sortConfig]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRecords = sortedRecords.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedRecords.length / itemsPerPage);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (columnName) => {
    if (sortConfig.key !== columnName) {
      return (
        <svg className="w-4 h-4 ml-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
        </svg>
      );
    }
    return sortConfig.direction === 'ascending' ? (
      <svg className="w-4 h-4 ml-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
      </svg>
    ) : (
      <svg className="w-4 h-4 ml-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          {/* Header and other existing components remain the same */}
            <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-800">Resource Summary</h1>
              <p className="text-sm text-gray-500 mt-1">Monitor usage and billing metrics</p>
            </div>
            
            <div className="flex items-center gap-3">
              <button
                onClick={handleReset}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Reset
              </button>
              <button
                onClick={() => setActivationModalOpen(true)}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Activation PWG
              </button>
            </div>
          </div>

          {/* Filters and Stats */}
          <div className="p-6 border-b border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">From Date</label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">To Date</label>
                <input
                  type="date"
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
              </div>
              <div className="flex items-end">
                <button
                  onClick={handleDateChange}
                  disabled={loading}
                  className="w-full py-2 px-4 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Applying...
                    </span>
                  ) : 'Apply Filter'}
                </button>
              </div>
            </div>

            {error && (
              <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg flex items-start gap-2">
                <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                {error}
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-5 rounded-xl border border-blue-200 shadow-sm">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-blue-600 font-medium">Total Billable Units</p>
                    <p className="text-2xl font-bold text-blue-900 mt-1">{bytesToMB(totalBillableUnits)} MB</p>
                  </div>
                  <div className="bg-blue-200 p-3 rounded-lg">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-5 rounded-xl border border-green-200 shadow-sm">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-green-600 font-medium">Total Charged Units</p>
                    <p className="text-2xl font-bold text-green-900 mt-1">{bytesToMB(totalChargedPrice)} MB</p>
                  </div>
                  <div className="bg-green-200 p-3 rounded-lg">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-5 rounded-xl border border-purple-200 shadow-sm">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-purple-600 font-medium">Free Units Applied</p>
                    <p className="text-2xl font-bold text-purple-900 mt-1">{bytesToMB(totalFreeUnits)} MB</p>
                  </div>
                  <div className="bg-purple-200 p-3 rounded-lg">
                    <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Section - Only showing the actions column for context */}
          <div className="p-6">


 <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
              <div className="relative w-full sm:w-96">
                <input
                  type="text"
                  placeholder="Search resources..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
                <svg className="absolute left-3 top-3 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>

              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-700 font-medium whitespace-nowrap">Show:</label>
                <select
                  value={itemsPerPage}
                  onChange={e => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>

            {loading ? (
              <div className="flex flex-col justify-center items-center py-20">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
                <p className="mt-4 text-gray-600">Loading data...</p>
              </div>
            ) : records.length === 0 ? (
              <div className="text-center py-16">
                <svg className="mx-auto h-16 w-16 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                </svg>
                <h3 className="mt-4 text-lg font-medium text-gray-900">No records found</h3>
                <p className="mt-2 text-sm text-gray-500">Try adjusting your search or filter criteria</p>
              </div>
            ) : (
              <>
                <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          S.No
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Resource
                        </th>
                        <th 
                          className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                          onClick={() => requestSort('total_units')}
                        >
                          <div className="flex items-center">
                            Total Units
                            {getSortIcon('total_units')}
                          </div>
                        </th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Billing Code
                        </th>
                        <th 
                          className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                          onClick={() => requestSort('total_billable_units')}
                        >
                          <div className="flex items-center">
                            Billable Units (MB)
                            {getSortIcon('total_billable_units')}
                          </div>
                        </th>
                        <th 
                          className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                          onClick={() => requestSort('total_free_units_applied')}
                        >
                          <div className="flex items-center">
                            Free Units (MB)
                            {getSortIcon('total_free_units_applied')}
                          </div>
                        </th>
                        <th 
                          className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors"
                          onClick={() => requestSort('total_charged_price')}
                        >
                          <div className="flex items-center">
                            Charged Price (MB)
                            {getSortIcon('total_charged_price')}
                          </div>
                        </th>
                        <th className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>

















            {/* <table className="min-w-full divide-y divide-gray-200"> */}
              {/* Table headers */}
              <tbody className="bg-white divide-y divide-gray-200">
                {currentRecords.map((rec, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {indexOfFirstItem + index + 1}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">{rec.resource}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-700">{rec.total_units.toLocaleString()}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full">
                              {rec.latestBillingCode}
                            </span>
                          </td>
                           <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-700">{bytesToMB(rec.total_billable_units)}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-700">{bytesToMB(rec.total_free_units_applied)}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-700">{bytesToMB(rec.total_charged_price)}</div>
                          </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center justify-center gap-2">
                        <button
                          onClick={() => handleSwapClick(rec)}
                          className="px-4 py-2 text-sm font-medium text-teal-700 bg-teal-50 border border-teal-300 rounded-lg hover:bg-teal-100 transition-all"
                          title="Swap MDN"
                        >
                          Swap
                        </button>
                        <button
                          onClick={() => handleBillingCodeClick(rec)}
                          className="px-4 py-2 text-sm font-medium text-teal-700 bg-teal-50 border border-teal-300 rounded-lg hover:bg-teal-100 transition-all"
                          title="Change Billing Code"
                        >
                          Billing
                        </button>
                         <button
                          onClick={() => handlePlanCodeClick(rec)}
                          className="px-4 py-2 text-sm font-medium text-teal-700 bg-teal-50 border border-teal-300 rounded-lg hover:bg-teal-100 transition-all"
                          title="Change Billing Code"
                        >
                          Swap PLan Code
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
           {totalPages > 1 && (
                  <div className="flex items-center justify-between mt-6 px-2">
                    <div className="flex-1 flex justify-between items-center sm:hidden">
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                      >
                        Previous
                      </button>
                      <span className="text-sm text-gray-700">
                        Page <span className="font-medium">{currentPage}</span> of <span className="font-medium">{totalPages}</span>
                      </span>
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                      >
                        Next
                      </button>
                    </div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                      <div>
                        <p className="text-sm text-gray-700">
                          Showing <span className="font-medium">{indexOfFirstItem + 1}</span> to{' '}
                          <span className="font-medium">
                            {Math.min(indexOfLastItem, sortedRecords.length)}
                          </span>{' '}
                          of <span className="font-medium">{sortedRecords.length}</span> results
                        </p>
                      </div>
                      <div>
                        <nav className="relative z-0 inline-flex rounded-lg shadow-sm -space-x-px" aria-label="Pagination">
                          <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="relative inline-flex items-center px-3 py-2 rounded-l-lg border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                          >
                            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          </button>
                          {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                            let pageNum;
                            if (totalPages <= 5) {
                              pageNum = i + 1;
                            } else if (currentPage <= 3) {
                              pageNum = i + 1;
                            } else if (currentPage >= totalPages - 2) {
                              pageNum = totalPages - 4 + i;
                            } else {
                              pageNum = currentPage - 2 + i;
                            }
                            return (
                              <button
                                key={pageNum}
                                onClick={() => setCurrentPage(pageNum)}
                                className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium transition-all ${
                                  currentPage === pageNum
                                    ? 'z-10 bg-blue-600 border-blue-600 text-white'
                                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                                }`}
                              >
                                {pageNum}
                              </button>
                            );
                          })}
                          <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className="relative inline-flex items-center px-3 py-2 rounded-r-lg border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                          >
                            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                            </svg>
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                )}
                </>
            )}
        </div>
                    </div>
</div>





      {/* Modals */}
      <Modal
        isOpen={activationModalOpen}
        onClose={() => setActivationModalOpen(false)}
        title="Activation PWG"
        size="lg"
      >
        <ActivationPWG />
      </Modal>

      {/* Swap MDN Modal */}
      <Modal
        isOpen={swapModalOpen}
        onClose={() => {
          setSwapModalOpen(false);
          setSelectedResource(null);
          resetModals();
        }}
        title="Swap ESN"
        size="md"
      >
        {selectedResource && (
          <div className="space-y-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Selected Resource</h4>
              <p className="text-lg font-semibold text-gray-900">{selectedResource.resource}</p>
            </div>
            
            {/* API Message */}
            {apiMessage.text && (
              <div className={`p-3 rounded-lg ${
                apiMessage.type === 'success' 
                  ? 'bg-green-50 text-green-700 border border-green-200' 
                  : 'bg-red-50 text-red-700 border border-red-200'
              }`}>
                {apiMessage.text}
              </div>
            )}

            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MDN *</label>
                <input
                  type="text"
                  value={swapForm.mdn}
                  onChange={(e) => setSwapForm({...swapForm, mdn: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter MDN"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New esn*</label>
                <input
                  type="text"
                  value={swapForm.sim}
                  onChange={(e) => setSwapForm({...swapForm, sim: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter new SIM ICCID"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Old Esn</label>
                <input
                  type="text"
                  value={swapForm.imei}
                  onChange={(e) => setSwapForm({...swapForm, imei: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter IMEI"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New ZIP Code (Optional)</label>
                <input
                  type="text"
                  value={swapForm.newZip}
                  onChange={(e) => setSwapForm({...swapForm, newZip: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter new ZIP code"
                />
              </div>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => {
                    setSwapModalOpen(false);
                    resetModals();
                  }}
                  disabled={apiLoading}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
                >
                  Cancel
                </button>
                <button 
                  onClick={handleSwapMDN}
                  disabled={apiLoading || !swapForm.mdn || !swapForm.sim}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {apiLoading ? (
                    <>
                      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Processing...
                    </>
                  ) : (
                    'Confirm Swap'
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Change Billing Code Modal */}
      <Modal
        isOpen={billingCodeModalOpen}
        onClose={() => {
          setBillingCodeModalOpen(false);
          setSelectedResource(null);
          resetModals();
        }}
        title="Change Billing Code"
        size="md"
      >
        {selectedResource && (
          <div className="space-y-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Selected Resource</h4>
              <p className="text-lg font-semibold text-gray-900">{selectedResource.resource}</p>
              <p className="text-sm text-gray-600 mt-1">
                Current Billing Code: <span className="font-medium">{selectedResource.latestBillingCode}</span>
              </p>
            </div>

            {/* API Message */}
            {apiMessage.text && (
              <div className={`p-3 rounded-lg ${
                apiMessage.type === 'success' 
                  ? 'bg-green-50 text-green-700 border border-green-200' 
                  : 'bg-red-50 text-red-700 border border-red-200'
              }`}>
                {apiMessage.text}
              </div>
            )}

            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">MDN *</label>
                <input
                  type="text"
                  value={billingCodeForm.mdn}
                  onChange={(e) => setBillingCodeForm({...billingCodeForm, mdn: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter MDN"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New Billing Code *</label>
                <select
                  type="text"
                  value={billingCodeForm.billingCode}
                  onChange={(e) => setBillingCodeForm({...billingCodeForm, billingCode: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                 
                 ><option value="">Select billing code</option>
                    {billingCodes.map(code => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select> 
              </div>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => {
                    setBillingCodeModalOpen(false);
                    resetModals();
                  }}
                  disabled={apiLoading}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
                >
                  Cancel
                </button>
                <button 
                  onClick={handleChangeBillingCode}
                  disabled={apiLoading || !billingCodeForm.mdn || !billingCodeForm.billingCode}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {apiLoading ? (
                    <>
                      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Processing...
                    </>
                  ) : (
                    'Update Code'
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>


      {/* Change Plan Code Modal */}
<Modal
  isOpen={planCodeModalOpen}
  onClose={() => {
    setPlanCodeModalOpen(false);
    setSelectedResource(null);
    resetModals();
  }}
  title="Change Plan Code"
  size="md"
>
  {selectedResource && (
    <div className="space-y-4">
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="text-sm font-medium text-gray-700 mb-2">Selected Resource</h4>
        <p className="text-lg font-semibold text-gray-900">{selectedResource.resource}</p>
      </div>

      {/* API Message */}
      {apiMessage.text && (
        <div className={`p-3 rounded-lg ${
          apiMessage.type === 'success' 
            ? 'bg-green-50 text-green-700 border border-green-200' 
            : 'bg-red-50 text-red-700 border border-red-200'
        }`}>
          {apiMessage.text}
        </div>
      )}

      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">MDN *</label>
          <input
            type="text"
            value={planCodeForm.mdn}
            onChange={(e) => setPlanCodeForm({...planCodeForm, mdn: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter MDN"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">SIM *</label>
          <input
            type="text"
            value={planCodeForm.sim}
            onChange={(e) => setPlanCodeForm({...planCodeForm, sim: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter SIM"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">New Plan ID *</label>
          <select
            type="text"
            value={planCodeForm.newPlanID}
            onChange={(e) => setPlanCodeForm({...planCodeForm, newPlanID: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter new Plan ID"
            required
          >
             <option value="">Select plan ID</option>
                    {plans.map(plan => (
                      <option key={plan.id} value={plan.id}>
                        ({plan.id}) {plan.name}
                      </option>
                    ))}
                  </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">New ZIP Code</label>
          <input
            type="text"
            value={planCodeForm.newZip}
            onChange={(e) => setPlanCodeForm({...planCodeForm, newZip: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter new ZIP code"
          />
        </div>
        
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={() => {
              setPlanCodeModalOpen(false);
              resetModals();
            }}
            disabled={apiLoading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button 
            onClick={handleChangePlanCode}
            disabled={apiLoading || !planCodeForm.mdn || !planCodeForm.sim || !planCodeForm.newPlanID}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {apiLoading ? (
              <>
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Processing...
              </>
            ) : (
              'Change Plan'
            )}
          </button>
        </div>
      </div>
    </div>
  )}
</Modal>
    </div>
  );
}

export default ResourceSummaryTable;